module.exports = __webpack_public_path__ + "img/aa1a4cae47690ccd8a848e2bed5560606d90dd98.ffa1e942.png";